import React, { useMemo, useState } from 'react';
import { useSnackbar } from 'hooks/useSnackbar';

const valueOnlyHasNumbers = (value: string) => {
  const regex = /^\d+$/;
  return regex.test(value);
};

export const useFilterValidation = () => {
  const { Snackbar, toggleSnackbar, isSnackbarOpen } = useSnackbar({
    autoHideDuration: 5000,
    severity: 'error',
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  });

  const [message, setMessage] = useState('');

  const SnackbarFilterValidation = useMemo(() => {
    // eslint-disable-next-line react/display-name
    return () => <Snackbar>{message}</Snackbar>;
  }, [isSnackbarOpen, message]);

  const setSnackbarMessage = (filterKey = '') => {
    setMessage(`${filterKey} não pode conter letras ou caracteres especiais`);
    toggleSnackbar();
  };

  const isFilterTypeValid = (key: string, value: string) => {
    if (key === 'Nome do Produto') {
      return true;
    }

    if (valueOnlyHasNumbers(value)) {
      return true;
    }

    setSnackbarMessage(key);
    return false;
  };

  return { SnackbarFilterValidation, isFilterTypeValid };
};
